/**
 * A localStorage season date can legitimately be missing, but it can also hold
 * the literal string "Invalid date" — that's what moment.js serialises an
 * unparseable date to, and it gets written into
 * currentPlayingseasonStartDate / ...EndDate when a team has NULL season dates.
 * If that junk reaches the PHP `new DateTime(...)` calls it throws a fatal
 * DateMalformedStringException on PHP 8.3. Treat it as absent everywhere.
 */
function isUsableDate(value) {
  if (!value) return false;
  const v = String(value).trim();
  if (v === "" || v.toLowerCase() === "invalid date") return false;
  return !isNaN(new Date(v).getTime());
}

export default {
  methods: {
    /** Season start date from localStorage, or null if missing/invalid. */
    getSeasonStartDateSafe() {
      const start = localStorage.getItem("currentPlayingseasonStartDate");
      return isUsableDate(start) ? start : null;
    },

    extendSeasonEndDateToFullYear() {
      const startDate = localStorage.getItem("currentPlayingseasonStartDate");
      const endDate = localStorage.getItem("currentPlayingseasonEndDate");

      // Handle missing / invalid localStorage values
      if (!isUsableDate(startDate) || !isUsableDate(endDate)) {
        // Return end of current year as fallback
        const now = new Date();
        return `${now.getFullYear()}-12-31`;
      }

      // Extend the end to one full year after the start, so Full Season covers
      // the whole season for BOTH season styles. The old logic took the year
      // from the end date + month/day from the start — OK for UK cross-year
      // seasons (Aug 2025–May 2026 → Aug 2026), but for a calendar season
      // (AU Jan–Dec / Mar–Sep, where start & end share a year) it collapsed to
      // the start date and blanked every game.
      const year = parseInt(startDate.substring(0, 4), 10) + 1;
      return `${year}${startDate.substring(4, 10)}`;
    },
  },
};
